// Иконка Скриптов (внутриигровой валюты).
// Заменяет старый текстовый символ «◆». Использует /img/ui/scripts.svg
// (гексагон + стилизованный </> в центре).
//
// Использование:
//   <ScriptsIcon size={14} />              — рядом с числом
//   <ScriptsIcon size={20} className="…" /> — крупнее, в плашке
//
// SVG отдаётся как обычная картинка, чтобы можно было заменить файл
// без пересборки и не тащить inline-разметку через JS.

interface Props {
  size?: number;            // px, default 16
  className?: string;
  style?: React.CSSProperties;
  alt?: string;             // для скрин-ридеров
}

export function ScriptsIcon({ size = 16, className, style, alt = 'Скрипты' }: Props) {
  return (
    <img
      src="/img/ui/scripts.svg"
      alt={alt}
      width={size}
      height={size}
      className={className}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        flexShrink: 0,
        ...style
      }}
    />
  );
}
